import React, { useMemo, useRef, useState } from "react";
import ObserverEmitter, { EVENTS } from "../../emitter/Observer";
import { useDispatch, useSelector } from "react-redux";
import { useRouterDetectNavigation } from "../../hooks/useRouterDetectNavigation";
import { changueReturnHome } from "../../store/slices/menu/menu";
import { audiosAssets } from "../../assets/audio";

export const PercentExperencia = () => {
	const { activitiesInformation } = useSelector((state) => state.menu);
	const [activeAnimation, setActiveAnimation] = useState(false)
	const dispatch = useDispatch()
	const puntuaionref = useRef(null);
	const buttonref = useRef(null);

	ObserverEmitter.on(EVENTS.hiddenMenusAnimations, () => {
		setActiveAnimation(false)
	});
	ObserverEmitter.on(EVENTS.showMenuAnimations, () => {
		setActiveAnimation(true)
	});

	const progressTeam = useMemo(() => {
		const sumTotal = Object.entries(activitiesInformation).reduce(
			({ total, totalWon }, [key, value]) => {
				const { task } = value;
				const sumTaskPoint = task.reduce((sum, value) => {
					const total = value?.isComplete ? 1 : 0;
					return sum + total;
				}, 0);
				return {
					total: total + task.length,
					totalWon: totalWon + sumTaskPoint,
				};
			},
			{ total: 0, totalWon: 0 }
		);
		const divider = sumTotal.totalWon / sumTotal.total;
		if (isNaN(divider)) {
			return 0;
		}
		const percent = parseFloat((divider * 100).toFixed(2));
		return percent;
	}, [activitiesInformation]);

	const navigateRoute = useRouterDetectNavigation(activitiesInformation);

	return (
		<>
			<div
				ref={puntuaionref}
				className={`fixed z-20 pt-4 w-100-212 md:w-100-470 flex justify-center items-center animate__animated ${activeAnimation ? "animate__fadeInDown" : "animate__fadeOutUp"}`}
			>
				<div className="px-[6px] py-[6px] bg-[#e0f2fe] rounded-lg">
					<div className="bg-white w-[192px] md:w-[289px] h-[48px] md:h-[70px] rounded-lg">
						<div className="flex flex-col justify-center text-center  h-full w-full px-4 bg-[#1e3aba] rounded-lg ">
							<p className="pt-0 text-white text-[8px] md:text-sm font-semibold">Mi Progreso</p>
							<div className="pt-2 md:pt-1">
								<div className="relative w-full bg-[#FDE68A] h-2 md:h-4 rounded-lg">
									<div className="absolute w-full h-2 md:h-4 flex justify-center items-center">
										<p className="text-[#F97316] text-[8px] md:text-xs font-semibold">{progressTeam}%</p>
									</div>
									<div className="absolute bg-[#FBBF24] h-2 md:h-4 rounded-lg" style={{ width: `${progressTeam}%` }}></div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			{/* boton */}
			<div
				ref={buttonref}
				className={`fixed z-20 bottom-0 pb-4 w-100-212 md:w-100-470 flex justify-center items-center md:hidden animate__animated ${activeAnimation ? "animate__fadeInUp" : "animate__fadeOutDown"}`}
			>
				<button
					onClick={() => {
						ObserverEmitter.emit(EVENTS.audiosEvents.createAudioActionButton, audiosAssets.barraNavegacion.completeNavigation)
						// navigator(navigateRoute);
						window.location.href = navigateRoute;
						dispatch(changueReturnHome(false))
					}}
					className="boxShadowButtons bg-yellow_primary h-10 w-[256px] rounded-xl text-white text-[20px] font-bold"
				>
					Continuar curso
				</button>
			</div>
		</>
	);
};
